import React, { useState, useEffect } from 'react';

const TimerDemo = () => {
  const [timeRemaining, setTimeRemaining] = useState(596); // 9:56 to match user's screenshot
  const [isTimerActive, setIsTimerActive] = useState(true);

  // Timer effect
  useEffect(() => {
    if (isTimerActive && timeRemaining > 0) {
      const timer = setInterval(() => {
        setTimeRemaining(prev => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (timeRemaining === 0) {
      setIsTimerActive(false);
    }
  }, [isTimerActive, timeRemaining]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const getTimerColor = () => {
    if (timeRemaining > 300) return 'text-emerald-400'; // Green
    if (timeRemaining > 120) return 'text-yellow-400';  // Yellow
    return 'text-rose-400'; // Red
  };

  const getTimerProgress = () => {
    return ((600 - timeRemaining) / 600) * 100;
  };

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Sophisticated Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.92), rgba(30, 41, 59, 0.88)), url('https://images.unsplash.com/photo-1671119525965-21bc08cfed60')`,
        }}
      ></div>
      
      {/* Elegant Overlay Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="w-full h-full"
          style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, rgba(244,63,94,0.4) 1px, transparent 0)`,
            backgroundSize: '60px 60px'
          }}
        ></div>
      </div>

      {/* Floating Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute w-3 h-3 bg-rose-400/20 rounded-full"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `float-elegant ${4 + Math.random() * 3}s ease-in-out infinite`,
              animationDelay: `${i * 0.8}s`
            }}
          ></div>
        ))}
      </div>

      <div className="relative z-10 min-h-screen flex items-center justify-center px-4 py-8">
        <div className="max-w-4xl w-full">
          
          {/* Timer Removed - Clean Interface */}
          <div className="text-center mb-8">
            <div className="bg-black/40 backdrop-blur-md rounded-3xl p-6 border border-white/10 shadow-2xl mb-6">
              <h2 className="text-2xl font-light text-white mb-4">Ready to Start Dating</h2>
              <p className="text-gray-300 text-lg">
                Your profile setup is ready to begin
              </p>
            </div>
          </div>

          {/* Comparison Section */}
          <div className="text-center">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 shadow-xl">
              <h3 className="text-xl font-semibold text-white mb-4">Timer Aesthetic Improvement</h3>
              <div className="grid grid-cols-1 gap-4 text-sm text-gray-300">
                <div className="text-green-400">✅ Removed bulky circular progress indicator</div>
                <div className="text-green-400">✅ Removed "Time Remaining" label</div>
                <div className="text-green-400">✅ Removed percentage display inside circle</div>
                <div className="text-green-400">✅ Added clean progress bar</div>
                <div className="text-green-400">✅ Improved typography and spacing</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimerDemo;